var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zy-ad wow fadeInDown",style:({
  backgroundImage: 'url(' + _vm.bg + ')',
  backgroundSize: '100% 100%',
  backgroundRepeat: 'no-repeat'
})},[_c('div',{staticClass:"zy-container"},[_c('h3',{staticClass:"index-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"index-desc"},[_vm._v(_vm._s(_vm.desc))])]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }